import { genericRoute } from 'utils/routeUtils';

import FormulaOneHomePage from './containers/FormulaOneHomePage';
import FormulaOneNav from './nav/FormulaOneNav';

export default genericRoute(FormulaOneHomePage, FormulaOneNav, 'formula1');



// WEBPACK FOOTER //
// ./modules/FormulaOne/routes.js